/**
 * API Configuration
 * Centralized backend URL configuration
 * Change this single value to update the backend URL across the entire application
 */

// Backend API base URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://hala.wadwarehouse.com';

// API endpoints
export const API_ENDPOINTS = {
  // Voice ordering
  voiceOrder: `${API_BASE_URL}/api/voice-order`,

  // RAG endpoints
  ragQuery: `${API_BASE_URL}/api/rag/query`,
  ragHealth: `${API_BASE_URL}/api/rag/health`,

  // Menu endpoints
  menuItems: `${API_BASE_URL}/api/menu`,
  menuSearch: `${API_BASE_URL}/api/menu/search`,

  // Order endpoints
  createOrder: `${API_BASE_URL}/api/orders`,
  getOrder: (orderId) => `${API_BASE_URL}/api/orders/${orderId}`,

  // Health check
  health: `${API_BASE_URL}/api/health`
};

// Export the base URL for any custom endpoint construction
export default API_BASE_URL;
